import CardTable from "components/CardTable/CardTable";
import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import WidgetsIcon from "@material-ui/icons/Widgets";
import { useDispatch, useSelector } from "react-redux";
import { saveInventory } from "redux/actions/inventories/inventoriesAction";
import { validateObject } from "helpers/validateObject";
import { setConfigFilteredInventories } from "redux/actions/inventories/inventoriesAction";
import { setConfigSortedInventories } from "redux/actions/inventories/inventoriesAction";
import { setConfigPageInventoriesCount } from "redux/actions/inventories/inventoriesAction";
import { setConfigPageInventories } from "redux/actions/inventories/inventoriesAction";
import { SaveInventoryButton } from "./SaveInventoryButton";
import { inventoryType } from "./inventoryType.enum";
import { columnsStation_actual, columnsStation_digital } from "./columnsStation";

export const StationTable = ({
  title = "",
  columns = [],
  keyInventory = "",
  endpoint = "",
  edited = "",
}) => {
  const keyTable = "localConfig";
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { inventory, station, localConfig } = useSelector(
    ({ inventories }) => inventories
  );
  const { localInventory } = inventory?.details;
  const { filtered, sorted, page, pageSize } = localConfig;

  const hist = useHistory();
  const handleGo = () => {
    hist.push("/admin/control-inventarios");
  };

  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilteredInventories(keyTable, e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSortedInventories(keyTable, e));
  }, []);

  const handlePageCount = useCallback((e) => {
    dispatch(setConfigPageInventoriesCount(keyTable, e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageInventories(keyTable, e));
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    const mapData = localInventory.map((inv) => {
      return {
        ...inv,
        currentPercentage:
          inv.currentPercentage === "" ? 0 : inv.currentPercentage,
      };
    });
    dispatch(saveInventory(inventory.id, endpoint, mapData, keyInventory));
  };

  // useHandleInventoryUnits(localInventory, type, keyInventory);

  useEffect(() => {
    validateObject(inventory, true) && handleGo();
  }, []);

  return (
    <>
      <CardTable
        hasHeader
        title={title}
        icon={<WidgetsIcon />}
        blockBtn
        columns={
          station.inventory_type === inventoryType.digital || station.inventory_type === inventoryType.progressive
            ? columnsStation_digital(endpoint, keyInventory, edited)
            : columns
        }
        data={inventory?.details?.localInventory}
        hasControl={inventory[edited] ? true : false}
        filtered={filtered}
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePageCount}
        onSortedChange={handleSort}
        isLoading={isLoadingComp?.loadingInventoryType}
        controls={<SaveInventoryButton handleSave={handleSave} />}
      />
    </>
  );
};
